import { createFileRoute, redirect } from '@tanstack/react-router'
import { Route as SessionsRoute } from '@routes/_auth/o/$orgId/sessions'

export const Route = createFileRoute('/_auth/o/$orgId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: SessionsRoute.to,
      params: { orgId: params.orgId },
    })
  },
})
